*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

/* ── Theme tokens. Light is the default; [data-theme="dark"] overrides. ──
   Phase 1 themes the app shell (sidebar, frame, nav). Screen interiors are
   converted to these tokens screen-by-screen in later passes. */
:root {
  color-scheme: light;
  --app-bg: #f2f2f7;
  --canvas: #f2f2f7;
  --surface: #ffffff;
  --surface-2: #e5e5ea;
  --text: #1c1c1e;
  --text-muted: #4e4e52;
  --text-faint: #6c6c70;
  --border: #dfdfe5;
  --border-soft: #e5e5ea;
  --sidebar-bg: #ffffff;
  --scrollbar: #c7c7cc;
  /* Fase 2 modo noche: tokens del CONTENIDO (cards, chips, campos, barras) */
  --card-bg: #ffffff;
  --inset-bg: #f2f2f7;
  --chip-bg: #e5e5ea;
  --field-bg: #f9f9fb;
  --field-border: #c7c7cc;
  --track: #e5e5ea;
  --bar-dim: #c7c7cc;
  --text-soft: #8e8e93;
  --text-fainter: #aeaeb2;
  --btn-strong: #1c1c1e;
  --tint-blue: #f0f4ff;
  --tint-blue-border: #cbdcff;
  --seg-active: #ffffff;
  --seg-active-text-inv: #ffffff;
  /* Nav de abajo: fondo translúcido con blur + píldora del ícono activo */
  --nav-bg: rgba(255, 255, 255, 0.86);
  --nav-pill: rgba(255, 59, 48, 0.10);
  --card-shadow: 0 4px 12px rgba(0, 0, 0, 0.03), 0 1px 3px rgba(0, 0, 0, 0.02);
  /* ── Capa semántica: estado y severidad (claro). Reutilizable en toda la app. ── */
  --accent: #ff3b30;  --on-accent: #ffffff;
  --accent-tint: #fff0ef;  --accent-tint-border: #ffd7d3;
  --info: #007aff;    --info-tint: #eef4ff;    --info-tint-border: #d3e3ff;
  --success: #1f9d57; --success-tint: #e9f8ee; --success-tint-border: #c3e9ce;
  --warn: #b4690e;    --warn-tint: #fff3e0;    --warn-tint-border: #f6d9a8;
  --danger: #e0352b;  --danger-tint: #ffece9;  --danger-tint-border: #ffccc7;
}
html[data-theme="dark"] {
  color-scheme: dark;
  --app-bg: #0b0b0c;
  --canvas: #0b0b0c;
  --surface: #1c1c1e;
  --surface-2: #2c2c2e;
  --text: #f2f2f7;
  --text-muted: #aeaeb2;
  --text-faint: #8e8e93;
  --border: #2c2c2e;
  --border-soft: #3a3a3c;
  --sidebar-bg: #141416;
  --scrollbar: #3a3a3c;
  --card-bg: #1c1c1e;
  --inset-bg: #26262a;
  --chip-bg: #2c2c2e;
  --field-bg: #232327;
  --field-border: #3f3f44;
  --track: #3a3a3c;
  --bar-dim: #48484d;
  --text-soft: #6e6e73;
  --text-fainter: #55555a;
  --btn-strong: #3a3a3c;
  --tint-blue: #1d2436;
  --tint-blue-border: #2c3a57;
  --seg-active: #48484d;
  --seg-active-text-inv: #f2f2f7;
  --nav-bg: rgba(20, 20, 22, 0.88);
  --nav-pill: rgba(255, 69, 58, 0.18);
  --card-shadow: 0 4px 16px rgba(0, 0, 0, 0.25), 0 1px 4px rgba(0, 0, 0, 0.15);
  /* ── Capa semántica: estado y severidad (oscuro). ── */
  --accent: #ff453a;  --on-accent: #ffffff;
  --accent-tint: rgba(255,69,58,0.16);  --accent-tint-border: rgba(255,69,58,0.34);
  --info: #0a84ff;    --info-tint: rgba(10,132,255,0.16);  --info-tint-border: rgba(10,132,255,0.34);
  --success: #30d158; --success-tint: rgba(48,209,88,0.15); --success-tint-border: rgba(48,209,88,0.32);
  --warn: #ff9f0a;    --warn-tint: rgba(255,159,10,0.15);   --warn-tint-border: rgba(255,159,10,0.34);
  --danger: #ff453a;  --danger-tint: rgba(255,69,58,0.16);  --danger-tint-border: rgba(255,69,58,0.34);
}
body, button, input, select, textarea {
  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "SF Pro", -system-ui, "Segoe UI", Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}
body { background: var(--app-bg); color: var(--text); transition: background 0.25s ease; }
#root { min-height: 100vh; }

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.2); }
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}
@keyframes chartScroll {
  from { transform: translateX(6px); }
  to   { transform: translateX(0px); }
}

/* ── Corazón en vivo: lub-dub (doble golpe) + onda expansiva por latido ── */
@keyframes vcLubDub {
  0%   { transform: scale(1); }
  16%  { transform: scale(1.13); }
  34%  { transform: scale(0.99); }
  50%  { transform: scale(1.07); }
  100% { transform: scale(1); }
}
.vc-beat-ring {
  position: absolute;
  border-radius: 50%;
  border: 2px solid;
  pointer-events: none;
  animation: vcRing 0.95s ease-out forwards;
}
/* Tope 1.38: a 240px son 331px — entra en cualquier teléfono (360px+) sin scroll lateral */
@keyframes vcRing {
  from { transform: scale(0.95); opacity: 0.55; }
  to   { transform: scale(1.38); opacity: 0; }
}
@media (prefers-reduced-motion: reduce) {
  .vc-beat-ring { display: none; }
}
/* Página /live: dvh evita que la barra de iOS Safari tape el footer */
.vc-live-root {
  min-height: 100vh;
  min-height: 100dvh;
}
input[type="date"], select { font-family: inherit; }
button { font-family: inherit; }

/* ── Mobile responsive ── */
@media (max-width: 600px) {
  /* HR hero: stack vertically */
  .hr-hero-grid {
    grid-template-columns: 1fr !important;
  }

  /* Big HR number: slightly smaller */
  .hr-number {
    font-size: 64px !important;
  }

  /* Charts: never clip — recharts needs overflow visible to draw axes */
  .recharts-wrapper {
    overflow: visible !important;
  }
  .recharts-responsive-container {
    min-height: 200px;
  }

  /* Hide non-essential on small screens */
  .hide-mobile { display: none !important; }

  /* Reduce base padding */
  body { font-size: 14px; }
}
